import React from "react";

import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
const BackButton = () => {
  const navigate = useNavigate();
  return (
    <div className=" flex items-center gap-x-2">
      <button
        className=" w-10 h-10 rounded-full border-2 border-gray-200 items-center justify-center flex"
        onClick={() => navigate(-1)}
      >
        <FiArrowLeft className="text-xl text-gray-400" />
      </button>
      {/* <p className=" text-lg text-gray-500 font-Nunito font-semibold">
        Go Back
      </p> */}
    </div>
  );
};

export default BackButton;
